import React, { useEffect, useState } from 'react';
import Screen from '../../components/layout/Screen';
import ScrollableContainer from '../../components/ScrollableContainer';
import { useGlobal } from '../../common/context/GlobalProvider';

const ApperenceScreen = () => {
  const { isDarkMode, setDarkMode } = useGlobal();

  const moonIcon = () => {
    return (
      <article className='min-w-[25vw] max-w-[25vw] min-h-[25vw] -rotate-90 rounded-full bg-gradient-to-r from-violet-500 to-indigo-300 flex items-end justify-end content-start'>
        <div className='min-w-[20vw] max-w-[20vw] min-h-[20vw] -rotate-45 rounded-full bg-black'></div>
      </article>
    );
  };

  const sunIcon = () => {
    return (
      <article className='min-w-[25vw] max-w-[25vw] min-h-[25vw] -rotate-45 rounded-full bg-gradient-to-r from-pink-600 to-orange-500'></article>
    );
  };

  return (
    <Screen
      screenOptions={{
        header: {
          title: 'Apperence',
          backBtnLabel: 'Settings',
          backBtnUrl: './../',
        },
      }}
    >
      <ScrollableContainer>
        <section className='flex flex-col items-center justify-center mt-7'>
          {isDarkMode ? moonIcon() : sunIcon()}

          <h2 className='dark:text-white text-lg mt-4 mb-1'>Choose a style</h2>
          <p className='dark:text-neutral-400 text-xs w-1/2 text-center'>
            Switch between dark and light mode just with one click!
          </p>
          <section className='mt-5 rounded-full bg-white dark:bg-neutral-900 p-2 dark:text-neutral-400 grid grid-cols-2 w-2/3'>
            <button
              className={`p-3 rounded-full  hover:dark:bg-neutral-700 ${
                !isDarkMode && 'dark:bg-neutral-800 bg-gray-100'
              }`}
              onClick={() => setDarkMode(false)}
            >
              Light
            </button>
            <button
              className={`p-3 rounded-full  hover:dark:bg-neutral-700 ${
                isDarkMode && 'dark:bg-neutral-800 bg-gray-100 '
              }`}
              onClick={() => setDarkMode(true)}
            >
              Dark
            </button>
          </section>
        </section>
      </ScrollableContainer>
    </Screen>
  );
};

export default ApperenceScreen;
